import { prompt, type PromptDefinition } from './models';

export const BUILDING_AUTOMATION_SPECIALIST_PROMPTS = [
    prompt(
        'Keep it running',
        'What control systems and integration points are documented for this building?',
        'Which buildings have incomplete control-system or integration inventories?'
    ),
    prompt(
        'Keep it running',
        "Which control sequences are documented for this building's systems?",
        'Compare documented control sequences across my buildings.'
    ),
    prompt(
        'Keep it running',
        'What recurring alarms or control faults are recorded for this building?',
        'Which buildings have recurring control alarms or faults needing investigation?'
    ),
    prompt(
        'Keep it running',
        'Find control schematics for this building showing…',
        'Find control schematics across my buildings showing…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'What commissioning and point-to-point test evidence exists for this building?',
        'Which buildings lack commissioning or point-to-point test evidence for controls?'
    ),
    prompt(
        'Improve performance',
        'What control schedules and setpoints are recorded for this building?',
        'Which buildings have control schedules or setpoints flagged for review?'
    ),
    prompt(
        'Keep it running',
        "What protocol or compatibility constraints are documented for this building's automation?",
        'Compare documented automation protocol and compatibility constraints across my buildings.'
    ),
    prompt(
        'Keep it running',
        'Find control-system commissioning records for this building concerning…',
        'Find control-system commissioning records across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "What changes to this building's control configuration are documented?",
        'Which buildings have control changes without updated configuration records?'
    ),
    prompt(
        'Manage risk',
        "What safety interlocks are documented for this building's automated systems?",
        'Which buildings have gaps in documented automation safety interlocks?'
    ),
    prompt(
        'Keep it running',
        'What unresolved automation handover items are recorded for this building?',
        'Which buildings have outstanding automation handover items to close?'
    ),
    prompt(
        'Keep it running',
        "Trace the control sequence for this building's…",
        'Compare control sequences across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
